import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { Subtag } from './models/SubtagModels';

export class ApiSubtag extends ApiHexaBase {
  public static override get baseUrl(): string {
    return `${ApiHexaBase.baseUrl}/subtags`;
  }

  public static async index(params: {
    page?: number;
    size?: number;
    search?: string;
  }) {
    const response = await ApiBase.get(this.baseUrl, params);
    return response.data.data as {
      total: number;
      subtags: Subtag[];
    };
  }

  public static async show(id: number | string) {
    const response = await ApiBase.get(`${this.baseUrl}/${id}`);

    return response.data.data as Subtag;
  }

  public static async update(id: number | string, data: Partial<Subtag>) {
    const response = await ApiBase.post(`${this.baseUrl}/${id}`, data);
    return response.data.data as Subtag;
  }
}
